import { useContext, useEffect } from 'react';
import { AppContext } from '../../config';
import { BusinessContextModel } from '../../model/BusinessContext.model';

export const useBusinessContext = (context: BusinessContextModel): void => {
  const { setBusinessContext } = useContext(AppContext);
  useEffect(() => {
    setBusinessContext(context);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
